<template>
  <div class="pageloader has-text-centered" :class="{'is-active':this.$store.getters.insight_isLoadingResultats}">
    <span class="title">{{ $t("loading.patienter") }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["insight_isLoadingResultats"])
  }
};
</script>